import { playerProfiles } from "@/data/athlete";
import { SectionHeader } from "./_shared";
import { ExternalLink } from "lucide-react";

export const ProfileLinks = () => {
  return (
    <section
      id="profiles"
      data-testid="profiles-section"
      className="border-t border-zinc-900 py-16 md:py-24 bg-[#0c0c0c]"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <SectionHeader
          eyebrow="06 — External"
          title="Player Profiles"
          kicker="Verified third-party profiles for stats and full game film."
          testId="profiles-header"
        />

        <div className="grid md:grid-cols-2 gap-4 md:gap-5">
          {playerProfiles.map((p) => (
            <a
              key={p.name}
              data-testid={`profile-link-${p.name.toLowerCase()}`}
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              referrerPolicy="no-referrer"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                const win = window.open(p.url, "_blank", "noopener,noreferrer");
                if (win) win.opener = null;
              }}
              className="group relative bg-[#141414] border border-zinc-800 p-6 md:p-8 hover:border-[#FF3B30] transition-colors cursor-pointer"
            >
              <div className="flex items-start justify-between gap-4">
                <div>
                  <div className="font-display text-4xl md:text-5xl text-white uppercase tracking-tight">
                    {p.name}
                  </div>
                  <div className="text-xs uppercase tracking-[0.25em] font-bold text-[#FF3B30] mt-2">
                    @{p.handle}
                  </div>
                </div>
                <ExternalLink className="h-5 w-5 text-zinc-500 group-hover:text-[#FF3B30] transition-colors shrink-0" />
              </div>
              <p className="text-sm text-zinc-400 mt-4 max-w-md">
                {p.description}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
